import { RuntimeContextKey, fetchNavigation } from '@nhst/composables';
import type { Navigation } from '@nhst/composables';
import type { PublicationContext } from '~/types';

/*
 * Navigation (header/footer) is fetched from the CDN on the server only.
 * fetchNavigation() never rejects. On failure it resolves to the header/footer baked into
 * runtimeConfig by headerFooterConfig() in nuxt.config.ts.
 */
export default defineNuxtPlugin(async (nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();
  const navigation = useState<Navigation | null>('navigation', () => null);

  /*
   * Resolve navigation before the context ref exists. On the server that means
   * awaiting the CDN; on the client the value is already in the payload, so
   * this is synchronous.
   */
  if (import.meta.server) {
    const { pubKey, env } = (runtimeConfig.navigation ?? {}) as { pubKey?: string; env?: 'prod' | 'stage' | 'test' };
    if (pubKey) {
      navigation.value = await fetchNavigation({ pubKey, env });
    }
  }

  const base = { ...runtimeConfig.public } as unknown as PublicationContext;
  const context = ref(navigation.value
    ? { ...base, config: { ...base.config, header: navigation.value.header, footer: navigation.value.footer } }
    : base);

  nuxtApp.vueApp.provide(RuntimeContextKey, context);
});
